import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import { create as createOrder } from '../../apis/orders';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useShowNotification } from '../../hooks/useShowNotification';

import { LoadingBlocker } from '../../components/common/ui/LoadingBlocker';
import { AdminBreadcrumb } from '../../components/admin/AdminBreadcrumb';
import { OrderForm } from '../../components/orders/OrderForm';
import { OrderFormLoading } from '../../components/orders/OrderFormLoading';

export const CreateOrderPage = () => {
    useDocumentTitle('Create Order');

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const showNotification = useShowNotification('Orders', 'file-invoice');

    const handleSubmit = async (form) => {
        try {
            setIsLoading(true);

            const orderItems = form.items.map((item) => ({
                ...item,
                price: item.product.price,
                product: item.product.id
            }));

            const response = await createOrder({
                ...form,
                items: orderItems
            });
            setIsLoading(false);

            if (!response.success) {
                showNotification(response.message, 'warning');
                return;
            }

            const { record } = response.data;
            showNotification(response.message, 'success');
            navigate(`/admin/orders/edit/${record.id}`);
        } catch (error) {
            setIsLoading(false);
            showNotification('Oops something went wrong.', 'danger');
        }
    };

    const handleReset = () => {
        navigate('/admin/orders');
    };

    return (
        <div className="admin-orders-page mb-5">
            <h1 className="h3">Create order</h1>
            <AdminBreadcrumb>
                <NavLink className="breadcrumb-item text-decoration-none" to="/admin/orders">
                    Orders
                </NavLink>
                <p className="breadcrumb-item text-muted text-decoration-none mb-0">Create</p>
            </AdminBreadcrumb>
            <OrderForm
                mode="create"
                onReset={handleReset}
                onSubmit={handleSubmit}
                className={isLoading ? 'd-none' : ''}
            />
            {isLoading && (
                <React.Fragment>
                    <OrderFormLoading />
                    <LoadingBlocker text="Creating order..." />
                </React.Fragment>
            )}
        </div>
    );
};
